var _rect, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBalanceIcon = function SvgBalanceIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5.5577,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4966_49718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3998 8C15.698 8.00114 13.3825 9.93174 12.8955 12.5893C15.2211 11.3167 18.138 12.1703 19.4106 14.4959C20.1963 15.9316 20.1963 17.6687 19.4106 19.1045C22.4518 18.5474 24.4655 15.6305 23.9084 12.5894C23.4212 9.93013 21.1033 7.99898 18.3998 8Z",
    fill: "#D5D5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 24.0002C14.2088 24.0002 15.9997 22.2093 15.9997 20.0001C15.9997 17.7909 14.2088 16 11.9996 16C9.79041 16 7.99951 17.7909 7.99951 20.0001C7.99951 22.2093 9.79041 24.0002 11.9996 24.0002Z",
    fill: "#6563FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1975 12C12.7307 12.0002 10.6657 13.8701 10.4214 16.3248C12.4501 15.4531 14.8012 16.3911 15.6729 18.4198C16.1058 19.4274 16.1058 20.5686 15.6729 21.5762C18.3107 21.3139 20.2366 18.9629 19.9743 16.325C19.7302 13.8699 17.6646 11.9998 15.1975 12Z",
    fill: "#A1A1ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4966_49718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBalanceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/balanceIcon.f484f22c.svg";
export { ForwardRef as ReactComponent };